import React, { MouseEventHandler } from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@emotion/react';

import { InstitutionType, Match } from '@dh/types';
import { DigitalhubDivider, FormattedOutput, PublishedDisplay } from '@dh/components';
import { Row, TitleMedium } from '@dh/styles';

import { MatchCardContainer } from './styles';
import { TagDisplay } from './TagDisplay';

interface Props {
    match: Match;
    viewer: InstitutionType;
    action?: React.ReactNode;
    onClick?: MouseEventHandler<HTMLDivElement> | undefined;
}

const MatchCard = ({ match, viewer, action, onClick }: Props) => {
    const { title, description } = match;
    const theme = useTheme();
    return (
        <MatchCardContainer onClick={onClick} sx={{ cursor: onClick ? 'pointer' : 'default' }}>
            <Row stretch>
                <TagDisplay match={match} viewer={viewer} />
                {action && <Box alignSelf={'end'}>{action}</Box>}
            </Row>
            <TitleMedium>{title}</TitleMedium>
            <FormattedOutput maxLength={100}>{description}</FormattedOutput>
            <DigitalhubDivider sx={{ borderColor: theme.colors.onSurface }} />
            <PublishedDisplay match={match} viewer={viewer} />
        </MatchCardContainer>
    );
};

export { MatchCard };
